// src/services/customerService.js
import api from '../config/axios';

const BASE_PATH = '/customers';

// Query Operations
export const getAllCustomers = async () => {
  const response = await api.get(BASE_PATH);
  return response.data;
};

export const getAllCustomersPaged = async (page = 0, size = 10, sort = 'customerName,asc') => {
  const response = await api.get(`${BASE_PATH}/paged`, {
    params: { page, size, sort }
  });
  return response.data;
};

export const getCustomerById = async (id) => {
  const response = await api.get(`${BASE_PATH}/${id}`);
  return response.data;
};

export const getCustomerByCode = async (customerCode) => {
  const response = await api.get(`${BASE_PATH}/code/${customerCode}`);
  return response.data;
};

export const searchCustomersByName = async (query) => {
  const response = await api.get(`${BASE_PATH}/search/name`, {
    params: { q: query }
  });
  return response.data;
};

export const searchCustomers = async (filters = {}, page = 0, size = 10) => {
  const response = await api.get(`${BASE_PATH}/search`, {
    params: {
      code: filters.code || undefined,
      name: filters.name || undefined,
      pic: filters.pic || undefined,
      page,
      size
    }
  });
  return response.data;
};

// Command Operations
export const createCustomer = async (customerData) => {
  const response = await api.post(BASE_PATH, customerData);
  return response.data;
};

export const updateCustomer = async (id, customerData) => {
  const response = await api.put(`${BASE_PATH}/${id}`, customerData);
  return response.data;
};

export const softDeleteCustomer = async (id) => {
  await api.delete(`${BASE_PATH}/${id}`);
};

export const hardDeleteCustomer = async (id) => {
  await api.delete(`${BASE_PATH}/${id}/permanent`, {
    params: { confirm: true }
  });
};

export const restoreCustomer = async (id) => {
  await api.post(`${BASE_PATH}/${id}/restore`);
};

export const cleanupOldDeletedCustomers = async (daysOld = 90) => {
  const response = await api.delete(`${BASE_PATH}/cleanup`, {
    params: { daysOld, confirm: true }
  });
  return response.data;
};

// Validation Operations
export const checkCustomerCode = async (customerCode) => {
  const response = await api.get(`${BASE_PATH}/check/code`, {
    params: { customerCode }
  });
  return response.data.exists;
};

export const checkEmail = async (email) => {
  const response = await api.get(`${BASE_PATH}/check/email`, {
    params: { email }
  });
  return response.data.exists;
};

// Statistics Operations
export const getCustomerStatistics = async () => {
  const response = await api.get(`${BASE_PATH}/statistics`);
  return response.data;
};

export default {
  getAllCustomers,
  getAllCustomersPaged,
  getCustomerById,
  getCustomerByCode,
  searchCustomersByName,
  searchCustomers,
  createCustomer,
  updateCustomer,
  softDeleteCustomer,
  hardDeleteCustomer,
  restoreCustomer,
  cleanupOldDeletedCustomers,
  checkCustomerCode,
  checkEmail,
  getCustomerStatistics
};